import React, { useState } from 'react';
import { FileTextIcon, Loader2Icon, CopyIcon, DownloadIcon, SparklesIcon, SplitSquareHorizontalIcon } from 'lucide-react';
export function SalesLetterGenerator() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [framework, setFramework] = useState('PAS');
  const [length, setLength] = useState('long');
  const [tone, setTone] = useState('empathetic');
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2500);
  };
  return <div className="max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-561">
      <div data-id="element-562">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-563">
          Generador de Sales Letter
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-564">
          Crea cartas de venta de alta conversión basadas en el análisis de tu
          producto.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-565">
        <div className="space-y-2" data-id="element-566">
          <label className="block text-sm font-medium text-slate-700" data-id="element-567">
            Framework de Copy
          </label>
          <select value={framework} onChange={e => setFramework(e.target.value)} className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-568">
            <option value="PAS" data-id="element-569">PAS (Problema, Agitación, Solución)</option>
            <option value="AIDA" data-id="element-570">
              AIDA (Atención, Interés, Deseo, Acción)
            </option>
            <option value="BAB" data-id="element-571">BAB (Antes, Después, Puente)</option>
            <option value="STORY" data-id="element-572">StoryBrand Framework</option>
          </select>
        </div>

        <div className="space-y-2" data-id="element-573">
          <label className="block text-sm font-medium text-slate-700" data-id="element-574">
            Formato / Longitud
          </label>
          <select value={length} onChange={e => setLength(e.target.value)} className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-575">
            <option value="long" data-id="element-576">Long-form Sales Page</option>
            <option value="vsl" data-id="element-577">VSL Script (Video Sales Letter)</option>
            <option value="short" data-id="element-578">Short-form (Checkout Page)</option>
          </select>
        </div>

        <div className="space-y-2" data-id="element-579">
          <label className="block text-sm font-medium text-slate-700" data-id="element-580">
            Tono de Voz
          </label>
          <select value={tone} onChange={e => setTone(e.target.value)} className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-581">
            <option value="empathetic" data-id="element-582">Empático y Cercano</option>
            <option value="direct" data-id="element-583">Directo y Autoridad</option>
            <option value="urgent" data-id="element-584">Urgente y Escasez</option>
            <option value="storytelling" data-id="element-585">Storytelling Emocional</option>
          </select>
        </div>

        <div className="md:col-span-3 flex justify-end pt-4 border-t border-slate-100" data-id="element-586">
          <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 transition-colors" data-id="element-587">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-588" /> Escribiendo
                Copy...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-589" /> Generar Sales Letter
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden animate-in slide-in-from-bottom-4 duration-500" data-id="element-590">
          <div className="bg-slate-50 border-b border-slate-200 p-4 flex items-center justify-between" data-id="element-591">
            <div className="flex items-center gap-2" data-id="element-592">
              <FileTextIcon className="w-5 h-5 text-indigo-600" data-id="element-593" />
              <h3 className="font-semibold text-slate-900" data-id="element-594">
                Sales Letter Generada (Framework: {framework})
              </h3>
            </div>
            <div className="flex gap-2" data-id="element-595">
              <button className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors" title="Generar Variantes A/B" data-id="element-596">
                <SplitSquareHorizontalIcon className="w-5 h-5" data-id="element-597" />
              </button>
              <button className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors" title="Copiar" data-id="element-598">
                <CopyIcon className="w-5 h-5" data-id="element-599" />
              </button>
              <button className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors" title="Exportar" data-id="element-600">
                <DownloadIcon className="w-5 h-5" data-id="element-601" />
              </button>
            </div>
          </div>

          <div className="p-8 prose prose-slate max-w-none prose-headings:text-slate-900 prose-p:text-slate-700" data-id="element-602">
            <h1 className="text-3xl font-black text-center mb-8 text-red-600" data-id="element-603">
              Cómo pasar de "vender postres para ayudar en casa" a tener un
              negocio rentable que factura $2,000 al mes (sin salir de tu
              cocina)
            </h1>

            <p className="text-xl font-medium text-center text-slate-600 mb-12" data-id="element-604">
              Incluso si hoy sientes que regalas tu trabajo, no sabes poner
              precios y te aterra vender por redes sociales.
            </p>

            <h3 data-id="element-605">[PROBLEMA]</h3>
            <p data-id="element-606">
              Sé exactamente cómo te sientes. Te pasas horas en la cocina,
              horneando con amor, decorando cada detalle. Entregas el pedido, el
              cliente te dice "¡Qué rico estaba!", pero cuando revisas tu
              billetera a fin de mes... <strong data-id="element-607">no hay ganancia.</strong>
            </p>
            <p data-id="element-608">
              Sientes que trabajas solo para comprar más ingredientes. Te da
              miedo subir los precios porque piensas "es solo un postre casero,
              nadie me va a pagar más". Y mientras tanto, el cansancio se
              acumula y tu familia te pregunta si realmente vale la pena tanto
              esfuerzo.
            </p>

            <h3 data-id="element-609">[AGITACIÓN]</h3>
            <p data-id="element-610">
              La verdad duele:{' '}
              <strong data-id="element-611">
                estás subsidiando los antojos de tus clientes con tu tiempo y tu
                dinero.
              </strong>
            </p>
            <p data-id="element-612">
              Cada vez que calculas el precio "al ojo", cada vez que regalas una
              porción extra, cada vez que no cobras el empaque... estás
              perdiendo dinero. Y lo peor no es el dinero, es la frustración de
              sentir que tu talento no es valorado. Si sigues así, terminarás
              odiando la repostería, cerrando tu emprendimiento y volviendo a
              buscar un trabajo tradicional que te aleje de tus hijos.
            </p>

            <h3 data-id="element-613">[SOLUCIÓN]</h3>
            <p data-id="element-614">
              Pero no tiene que ser así. No necesitas un local comercial costoso
              ni equipos industriales para ser rentable. Lo que necesitas es un{' '}
              <strong data-id="element-615">sistema</strong>.
            </p>
            <p data-id="element-616">
              Presentando <strong data-id="element-617">El Método Porción-Rentable™</strong>. La guía
              definitiva paso a paso donde te enseño exactamente cómo costear,
              empaquetar y vender postres desde casa asegurando un margen mínimo
              del 60% en cada venta.
            </p>

            <div className="bg-yellow-50 p-6 rounded-xl border border-yellow-200 my-8" data-id="element-618">
              <h4 className="text-yellow-800 mt-0" data-id="element-619">
                ¿Qué vas a lograr en los próximos 30 días?
              </h4>
              <ul className="text-yellow-900" data-id="element-620">
                <li data-id="element-621">
                  Aprenderás a calcular el costo exacto de cada receta hasta el
                  último gramo de azúcar.
                </li>
                <li data-id="element-622">
                  Descubrirás cómo crear un menú corto pero altamente rentable
                  (adiós a tener 50 ingredientes distintos en la alacena).
                </li>
                <li data-id="element-623">
                  Sabrás cómo tomar fotos irresistibles con tu celular que hagan
                  que tus clientes te escriban por WhatsApp pidiendo "quiero
                  eso".
                </li>
                <li data-id="element-624">
                  Perderás el miedo a cobrar lo que tu trabajo realmente vale.
                </li>
              </ul>
            </div>

            <div className="text-center mt-12" data-id="element-625">
              <button className="bg-red-600 text-white font-bold text-xl px-8 py-4 rounded-xl shadow-lg hover:bg-red-700 transition-colors inline-block" data-id="element-626">
                SÍ, QUIERO RENTABILIZAR MIS POSTRES HOY
              </button>
              <p className="text-sm text-slate-500 mt-4" data-id="element-627">
                Garantía incondicional de 7 días. Acceso inmediato.
              </p>
            </div>
          </div>
        </div>}
    </div>;
}